import { useMemo } from "react"

const HEADER_SIZE = 96

const useTableOfContent = (contentStr = "") =>
  useMemo(() => {
    const [openH2Tag, closeH2Tag, openH3Tag, closeH3Tag] = [
      `<h2>`,
      `</h2>`,
      `<h3>`,
      `</h3>`,
    ]
    const sectionNamesH2 =
      // eslint-disable-next-line
      contentStr.match(new RegExp(/\<h2\>(.*?)\<\/h2\>/gi)) || []
    const sectionNamesH3 =
      // eslint-disable-next-line
      contentStr.match(new RegExp(/\<h3\>(.*?)\<\/h3\>/gi)) || []
    let content = contentStr
    let indexH2 = 0
    let indexH3 = 0
    for (const sectionName of sectionNamesH2) {
      const updatedSectionName = sectionName.replace(
        new RegExp(/\<h2\>/gi),
        `<h2 id="article-section-h2-${indexH2++}">`
      )

      content = content.replace(sectionName, updatedSectionName)
    }
    for (const sectionName of sectionNamesH3) {
      const updatedSectionName = sectionName.replace(
        new RegExp(/\<h3\>/gi),
        `<h3 id="article-section-h3-${indexH3++}">`
      )

      content = content.replace(sectionName, updatedSectionName)
    }

    const renderListElement = (id, content) => `<li 
            onclick="event.stopPropagation();window.scrollBy({ left: 0, behavior: 'smooth', top: document.getElementById('${id}').getBoundingClientRect().y - ${HEADER_SIZE} });"
          >
            <span>${content}</span>
          </li>`

    const isH3RelatedToH2 = (contentStr, h2Id, nextH2Id, h3Id) => {
      const h2IdIndex = contentStr.indexOf(h2Id)
      const nextH2IdIndex =
        typeof nextH2Id === "boolean"
          ? contentStr.length
          : contentStr.indexOf(nextH2Id)
      const h3IdIndex = contentStr.indexOf(h3Id)
      return h2IdIndex <= h3IdIndex && nextH2IdIndex >= h3IdIndex
    }

    const toc = sectionNamesH2.reduce((obj, sectionName, h2Index) => {
      const h2liId = `article-section-h2-${h2Index}`
      const h2li = renderListElement(
        h2liId,
        sectionName.slice(openH2Tag.length, sectionName.indexOf(closeH2Tag))
      )

      obj[h2liId] = {
        li: h2li,
        h3: sectionNamesH3
          .map((section, h3Index) => ({ section, h3Index }))
          .filter(({ section, h3Index }) =>
            isH3RelatedToH2(
              content,
              h2liId,
              h2Index === sectionNamesH2.length - 1
                ? true
                : `article-section-h2-${h2Index + 1}`,
              `article-section-h3-${h3Index}`
            )
          )
          .map(({ section, h3Index }) =>
            renderListElement(
              `article-section-h3-${h3Index}`,
              section.slice(openH3Tag.length, section.indexOf(closeH3Tag))
            )
          ),
      }

      return obj
    }, {})

    let resultStr = ""
    for (const h2Id in toc) {
      let { li, h3 } = toc[h2Id]
      if (h3.length) {
        li = li.replace(`</span>`, `</span><ul>${h3.join("")}</ul>`)
      }
      resultStr += li
    }

    return {
      toc: resultStr,
      content,
    }
  }, [contentStr])

export default useTableOfContent;